// Choosing the server in the apps (Connect, and links scanned on the landing page).
import type { InstanceInfo } from '../api/types'
import { parseServerInput, setServer } from '../platform'

/**
 * Checks that the address or link is an hrth server, makes it this app's server and opens
 * the link's page on it (a fresh start, so the session, socket and fonts use it).
 * Resolves with an error to show when it can't; on success the page reloads.
 */
export async function connectTo(input: string): Promise<string> {
  const target = parseServerInput(input)
  if (!target) return 'That doesn’t look like a server address or a link.'
  try {
    const resp = await fetch(`${target.origin}/api/v1/instance`)
    if (!resp.ok) throw new Error(`the server answered ${resp.status}`)
    const info = (await resp.json()) as Partial<InstanceInfo>
    if (typeof info.name !== 'string') throw new Error('that isn’t an hrth server')
    setServer(target.origin)
    window.location.replace(target.path)
    return ''
  } catch (e) {
    return `Couldn’t reach ${target.origin}: ${e instanceof Error ? e.message : String(e)}`
  }
}
